export const pathAPI = {
  category: "admin/categories",
  categoryDetail: "admin/categories",
  login: "admin/login",
  resendOTP: "admin/login/resend/otp",
  verify: "admin/login/verify",
  refreshToken: "admin/refresh-token",
  register: "admin/register",
  country: "admin/setting/countries",
  countries: "admin/setting/countries",
  settingLanguage: "admin/setting/languages",
  cancelReason: "admin/settings/cancelReasons",
  outlet: "admin/outlets",
  orders: "admin/orders",
  cities: "admin/setting/countries/:slug/cities",
  district: "admin/setting/countries/:slug/cities/:id",
  languages: "admin/common/languages",
  salons: "admin/outlets",
  salonsRegistration: "admin/outlets/registrations",
  salonsRegistrationDetail: "admin/outlets/:id/info",
  settingSalon: "admin/outlets/:id/settings",
  bussinessTypes: "admin/common/business-types",
  photoSalon: "admin/outlets/:id/photos",
  uploadImage: "admin/common/media/upload/:type",
  uploadMultiImage: "admin/common/medias/upload/:type",
  supportTicket: "admin/help-support",
  outletChangeRequests: "admin/outlet-change-requests",
  notifications: "admin/notifications",
  availableOutlet: "admin/common/available-outlets",
  adminUsers: "admin/users",
  me: "admin/me",
  roles: "admin/roles",
  rolesAssignable: "admin/roles/assignable",
  roleAuditLogs: "admin/roles/audit-logs",
  permissions: "admin/permissions",
  forgetPasswordRequset: "admin/reset-password/request",
  forgetPassword: "admin/reset-password",
  appUsers: "admin/app-users",
  history: "admin/logs",
  systemConfig: "admin/setting/system-config",
  systemConfigs: "admin/setting/system-configs",
  loyalty: "admin/loyalty",
  aiChat: "admin/ai-chat",
  webhookClients: "admin/webhook-clients",
  billingCountryPricingConfigs: "admin/billing/country-pricing-configs",
  billingPaymentGateways: "admin/billing/payment-gateways",
  billingExchangeRates: "admin/billing/exchange-rates",
  billingCountryPaymentGateways: "admin/billing/country-payment-gateways",
  billingCancellationPolicies: "admin/billing/cancellation-policies",
  billingRefundRequests: "admin/billing/refund-requests",
  coupon: "admin/coupon",
  couponLookupCountries: "admin/coupon/lookup/countries",
  couponLookupOutlets: "admin/coupon/lookup/outlets",
  couponPendingCount: "admin/coupon/pending-count",
  errorMessages: "admin/setting/message-codes",
  packages: "admin/packages",
  packageMenus: "admin/packages/:packageId/menus",
  packageCountryPrices: "admin/packages/:packageId/prices",
  packagePricingStrategy: "admin/packages/:packageId/pricing-strategy",
  unassignedMenus: "admin/menu-items/unassigned",
  menuItems: "admin/menu-items",
  reviewsPending: "admin/reviews/pending",
  reviewsModerate: "admin/reviews/:reviewId/moderate",
};
